var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EditorMenuBubble',{attrs:{"editor":_vm.editor},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var isActive = ref.isActive;
var getNodeAttrs = ref.getNodeAttrs;
var commands = ref.commands;
return [_c('EditTextTypeControls',{attrs:{"is-active":isActive,"get-node-attrs":getNodeAttrs,"commands":commands}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }